import React from "react";
import { Drawer } from "../../../components/Drawer";
import SelectCategoryStep from "./SelectCategoryStep";
import { CategoryDrink } from "./FormSteps/CategoryDrink";
import { CategoryStep } from "./FormSteps/CategoryStep";
import { CategoryPizza } from "./FormSteps/CategoryPizza";

const CategoryMode = {
	PIZZA: "pizza",
	DRINK: "drink",
	STEP: "step",
};

export class AddCategory extends React.Component {
	state = {
		step: 0,
		steps: null,
		currentStep: 0,
		disabled: false,
		category: {
			type: 'category',
			name: null,
			mode: null,
			single_size: false,
			default_sizes: undefined,
			show: true,
			highlight: false,
			availability: null,
			extra_ingredients: [],
			doughs: [],
			edges: [],
			items: [],
			sizes: [],
		}
	}

	getHeaderTitle() {
		const { category, step } = this.state;

		const titles = {
			pizza: "Pizza",
			drink: "Bebida",
			step: "Outros",
		};

		if (category.mode && step >= 2) {
			return `${titles[category.mode]} - ${category.sizes.length > 1 ? "Vários tamanhos" : "Tamanho único"}`;
		}

		if (category.mode && step > 0) {
			return `Adicionar categoria - ${titles[category.mode]}`;
		}

		return "Adicionar categoria";
	}

	setCategoryMode({ mode }) {
		const { category } = this.state;
		this.setState({ 
			step: 1,
			category: { ...category, mode } 
		});
	}

	render() {
		const { open, setOpen, onSave } = this.props;
		const { category, step } = this.state;

		const getHeaderTitle = this.getHeaderTitle.bind(this);
		const setCategoryMode = this.setCategoryMode.bind(this);

		return (
			<Drawer visible={open} closeInFade={false} title={getHeaderTitle()} onClose={() => setOpen(false)} withoutTransition>
				{step === 0 && <SelectCategoryStep category={category} mountPayload={setCategoryMode} />}
				{step !== 0 && category.mode === CategoryMode.DRINK && (
					<CategoryDrink
						category={category}
						onPrev={() => this.setState({ step: 0, category: { ...category, mode: null } })}
						onSave={(categoryData) => onSave && onSave(categoryData)}
					/>
				)}
				{step !== 0 && category.mode === CategoryMode.STEP && (
					<CategoryStep
						category={category}
						onPrev={() => this.setState({ step: 0, category: { ...category, mode: null } })}
						onSave={(categoryData) => onSave && onSave(categoryData)}
					/>
				)}
				{step !== 0 && category.mode === CategoryMode.PIZZA && (
					<CategoryPizza
						category={category}
						onPrev={() => this.setState({ step: 0, category: { ...category, mode: null } })}
						onSave={(categoryData) => onSave && onSave(categoryData)}
					/>
				)}
			</Drawer>
		)
	}
}